import React, { useState } from "react";
import Script from "react-load-script";

const Razorpay = () => {
  const [amount, setAmount] = useState("100");
  const [darkMode, setDarkMode] = useState(false);
  const [qrCode, setQrCode] = useState("");
  const [paymentStatus, setPaymentStatus] = useState("");
  const [orderId, setOrderId] = useState("");

  // Toggle dark mode
  const toggleDarkMode = () => {
    setDarkMode(!darkMode);
  };

  // Generate QR code (mock implementation)
  const generateQrCode = () => {
    // In a real app, you would generate this from your backend
    const mockQrCode = `https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=${encodeURIComponent(
      `razorpay://payment?amount=${amount * 100}&currency=INR`
    )}`;
    setQrCode(mockQrCode);
    setPaymentStatus("QR code generated. Scan to pay.");
  };

  // Load Razorpay script
  const [scriptLoaded, setScriptLoaded] = useState(false);

  const handleScriptLoad = () => {
    setScriptLoaded(true);
  };

  // Create order and initiate payment
  const initiatePayment = async () => {
    if (!scriptLoaded) {
      alert("Razorpay SDK is still loading. Please try again.");
      return;
    }

    // In a real app, you would call your backend to create an order
    // This is a mock implementation for test mode
    const mockOrderId = `order_${Math.random().toString(36).substr(2, 9)}`;
    setOrderId(mockOrderId);

    const options = {
      key: "rzp_test_YOUR_TEST_KEY", // Replace with your test key
      amount: amount * 100, // Amount is in paise (100 paise = 1 rupee)
      currency: "INR",
      name: "My Company",
      description: "Test Transaction",
      order_id: mockOrderId,
      handler: function (response) {
        setPaymentStatus(`Payment successful! Payment ID: ${response.razorpay_payment_id}`);
      },
      prefill: {
        name: "Test User",
        email: "test.user@example.com",
        contact: "9999999999",
      },
      notes: {
        address: "Test Address",
      },
      theme: {
        color: darkMode ? "#4f46e5" : "#2563eb",
      },
    };

    const rzp = new window.Razorpay(options);
    rzp.open();

    rzp.on("payment.failed", function (response) {
      setPaymentStatus(`Payment failed! Error: ${response.error.description}`);
    });
  };

  return (
    <div className={`min-h-screen transition-colors duration-300 ${darkMode ? "bg-gray-900 text-white" : "bg-gray-50 text-gray-900"}`}>
      <div className="container mx-auto px-4 py-8">
        <div className="flex justify-between items-center mb-8">
          <h1 className="text-3xl font-bold">Razorpay Payment Gateway</h1>
          <button
            onClick={toggleDarkMode}
            className={`px-4 py-2 rounded-lg ${darkMode ? "bg-indigo-600 text-white" : "bg-gray-200 text-gray-800"}`}
          >
            {darkMode ? "☀️ Light Mode" : "🌙 Dark Mode"}
          </button>
        </div>

        <div className={`max-w-2xl mx-auto p-6 rounded-lg shadow-lg ${darkMode ? "bg-gray-800" : "bg-white"}`}>
          <div className="mb-6">
            <h2 className="text-2xl font-semibold mb-4">Payment Details</h2>
            <p className="mb-4">Test Mode: <span className="font-bold text-yellow-500">Active</span></p>
            
            <div className="mb-4">
              <label htmlFor="amount" className="block mb-2 font-medium">
                Amount (INR)
              </label>
              <input
                type="number"
                id="amount"
                value={amount}
                onChange={(e) => setAmount(e.target.value)}
                className={`w-full p-3 border rounded-lg ${darkMode ? "bg-gray-700 border-gray-600" : "bg-white border-gray-300"}`}
                min="1"
                placeholder="Enter amount"
              />
            </div>

            <div className="flex flex-wrap gap-4 mt-6">
              <button
                onClick={initiatePayment}
                className="px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors flex-1 min-w-[200px]"
              >
                Pay with Razorpay
              </button>
              <button
                onClick={generateQrCode}
                className="px-6 py-3 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors flex-1 min-w-[200px]"
              >
                Generate QR Code
              </button>
            </div>
          </div>

          {qrCode && (
            <div className="mb-6">
              <h3 className="text-xl font-semibold mb-3">Scan QR Code to Pay</h3>
              <div className="flex flex-col items-center">
                <img src={qrCode} alt="Payment QR Code" className="w-48 h-48 mb-4 border p-2 rounded-lg" />
                <p className="text-sm text-gray-500 dark:text-gray-400">Amount: ₹{amount}</p>
              </div>
            </div>
          )}

          {paymentStatus && (
            <div className={`p-4 rounded-lg ${paymentStatus.includes("successful") ? "bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200" : paymentStatus.includes("failed") ? "bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200" : "bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200"}`}>
              {paymentStatus}
              {orderId && (
                <p className="mt-2">Order ID: {orderId}</p>
              )}
            </div>
          )}

          <div className="mt-8 pt-6 border-t border-gray-200 dark:border-gray-700">
            <h3 className="text-lg font-semibold mb-3">Test Card Details</h3>
            <div className={`p-4 rounded-lg ${darkMode ? "bg-gray-700" : "bg-gray-100"}`}>
              <p className="mb-2"><span className="font-medium">Card Number:</span> 4111 1111 1111 1111</p>
              <p className="mb-2"><span className="font-medium">Expiry:</span> Any future date</p>
              <p className="mb-2"><span className="font-medium">CVV:</span> Any 3 digits</p>
              <p className="mb-2"><span className="font-medium">Name:</span> Any name</p>
              <p className="text-sm text-gray-500 dark:text-gray-400">Note: This is for test mode only. No real money will be charged.</p>
            </div>
          </div>
        </div>
      </div>

      {/* Load Razorpay script */}
      <Script
        url="https://checkout.razorpay.com/v1/checkout.js"
        onLoad={handleScriptLoad}
      />
    </div>
  );
};

export default Razorpay;